import { get as getConfig } from '@lumapps/constants';

const { instanceId } = getConfig();

/**
 * The default max results when fetching all metadata.
 */
export const FETCH_ALL_METADATA_MAX_RESULTS = 500;

/**
 * Default metadata instance list params
 */
export const DEFAULT_INSTANCE_LIST_PARAMS = { instance: instanceId, withInheritance: true } as const;
